import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "col-md-6 mx-auto" }
const _hoisted_2 = { class: "dl-horizontal" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("dt", null, "ID", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("dt", null, "Name", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("dt", null, "Cover color", -1)
const _hoisted_6 = { class: "d-flex align-items-center" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("dt", null, "Type", -1)
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("dt", null, "Status", -1)
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("dt", null, "Image", -1)
const _hoisted_12 = { class: "card-footer bg-white border border-light" }
const _hoisted_13 = { class: "col text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_image_holder = _resolveComponent("app-image-holder")!
  const _component_app_button = _resolveComponent("app-button")!
  const _component_app_card = _resolveComponent("app-card")!

  return (_openBlock(), _createBlock(_component_app_card, {
    class: "col-lg-8 mx-auto",
    label: "Collection Detail"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("dl", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("dd", null, _toDisplayString(_ctx.model.collectionId), 1),
          _hoisted_4,
          _createElementVNode("dd", null, _toDisplayString(_ctx.model.name), 1),
          (_ctx.model.coverColor)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _hoisted_5,
                _createElementVNode("dd", _hoisted_6, [
                  _createElementVNode("span", {
                    class: "mr-2",
                    style: _normalizeStyle([{"width":"20px","height":"20px"}, { backgroundColor: `#${_ctx.model.coverColor}` }])
                  }, null, 4),
                  _createTextVNode(" " + _toDisplayString(_ctx.model.coverColor), 1)
                ])
              ], 64))
            : _createCommentVNode("", true),
          _hoisted_7,
          _createElementVNode("dd", {
            innerHTML: _ctx.renderOption(_ctx.CollectionSelectOptions.Type, _ctx.model.type)
          }, null, 8, _hoisted_8),
          _hoisted_9,
          _createElementVNode("dd", {
            innerHTML: _ctx.renderOption(_ctx.CollectionSelectOptions.Status, _ctx.model.status)
          }, null, 8, _hoisted_10),
          _hoisted_11,
          _createElementVNode("dd", null, [
            _createVNode(_component_app_image_holder, {
              image: _ctx.model.image,
              status: _ctx.model.imageStatus
            }, null, 8, ["image", "status"])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _createVNode(_component_app_button, {
            name: "Edit",
            icon: "fa-edit",
            theme: "info",
            to: {
                        name: _ctx.ROUTE_NAME_COLLECTION.EDIT(_ctx.model.type),
                        params: { collectionId: _ctx.model.collectionId }
                    }
          }, null, 8, ["to"]),
          _createVNode(_component_app_button, {
            name: "Translate",
            theme: "info",
            icon: "fa-language",
            to: {
                        name: _ctx.ROUTE_NAME_COLLECTION.TRANSLATE(_ctx.model.type),
                        params: { collectionId: _ctx.model.collectionId }
                    }
          }, null, 8, ["to"]),
          _createVNode(_component_app_button, {
            name: _ctx.model.type == _ctx.CollectionType.Journey ? 'Levels' : 'Puzzles',
            theme: "info",
            icon: "fa-gift",
            to: {
                        name: _ctx.ROUTE_NAME_COLLECTION.ITEM.INDEX(_ctx.model.type),
                        params: { collectionId: _ctx.model.collectionId }
                    }
          }, null, 8, ["name", "to"]),
          (_ctx.model.canPublish)
            ? (_openBlock(), _createBlock(_component_app_button, {
                key: 0,
                name: "Publish",
                theme: "success",
                icon: "fa-play",
                onClick: _withModifiers(_ctx.actions.publish, ["prevent"])
              }, null, 8, ["onClick"]))
            : _createCommentVNode("", true),
          (_ctx.model.canUnpublish)
            ? (_openBlock(), _createBlock(_component_app_button, {
                key: 1,
                name: "Unpublish",
                theme: "warning",
                icon: "fa-stop",
                onClick: _withModifiers(_ctx.actions.unpublish, ["prevent"])
              }, null, 8, ["onClick"]))
            : _createCommentVNode("", true),
          (_ctx.model.canDelete)
            ? (_openBlock(), _createBlock(_component_app_button, {
                key: 2,
                name: "Delete",
                icon: "fa-trash-alt",
                theme: "danger",
                onClick: _withModifiers(_ctx.actions.remove, ["prevent"])
              }, null, 8, ["onClick"]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _: 1
  }))
}